module.exports = __webpack_public_path__ + "img/yun1.e373ed3f.png";